import baseApi from "./baseApi";

export default {
    /**
     * Fetch User Unprocessed Pick Records from Server who matches token.
     * @return {Object} -- Unprocessed Prick Records
     */
    async getUnproccessedPickRecords() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/pickrecords/unprocessed");
        
        return result.data;
    }
}